import PageWrap from '@/components/PageWrap/index.vue'
import JtTable from '@/components/JtTable/index.vue'
// import PublicFilter from '@/components/PublicFilter/index.vue'
// import PageHeader from '@/components/PageHeader/index.vue'
import { VueConstructor } from 'vue'

export default {
  install(Vue: VueConstructor) {
    Vue.component('page-wrap', PageWrap)
    Vue.component('jt-table', JtTable)
    // Vue.component('public-filter', PublicFilter)
    // Vue.component('page-header', PageHeader)
  }
}
